
const Flash = (state = { message: null, success: true }, action) => {
  switch (action.type) {
    case 'SET_FLASH_MESSAGE':
      return {
        ...state,
        message: action.message,
        success: action.success,
      };
    case 'SET_FLASH_MESSAGE_NULL':
      return {
        ...state,
        message: '',
      };
    default:
      return state;
  }
};

export default Flash;



// WEBPACK FOOTER //
// ./src/reducers/FlashReducer.js